import clsx from "clsx";

import { Icon } from "@smart/itops-sb-design-system-dom";

import { fieldName } from "../../hooks";

export type ErrorDisplayProps = {
  uri: string;
  index?: number;
  error?: string;
};

export const ErrorDisplay = ({
  uri,
  index,
  error,
  className,
}: ErrorDisplayProps & { className?: string }) =>
  error ? (
    <div
      id={fieldName({ field: { uri }, index, suffix: "error" })}
      className={clsx(
        "flex items-center gap-small whitespace-break-spaces text-red-550 text-caption font-semibold",
        className,
      )}
    >
      <Icon name="regularCircleExclamation" className="w-[1rem] h-[1rem]" />
      <div>{error}</div>
    </div>
  ) : null;
